//记得在 src\components\lang\zhLoad.js 里面添加对象
const plant = {
  plantCode:'基地编码',
  plantName: '基地名称',
  createTime: '创建时间',
  faceRecognitionEnabled: '是否启用人脸识别',
  faceRecognitionExpireMinutes: '人脸识别有效期（分）',
  msg: {
  }
};
export default plant



// WEBPACK FOOTER //
// ./src/page/md/plant/lang/plant.zh.js